/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { NamirasoftAccountServer } from "./NamirasoftAccountServer";
import { NamirasoftAccountServerBase } from "./NamirasoftAccountServerBase";
import { NamirasoftAccountToken } from "./NamirasoftAccountToken";
import { UserCreateByGoogleRow } from "./row/UserCreateByGoogleRow";
import { UserCreateRow } from "./row/UserCreateRow";
import { UserFullRow } from "./row/UserFullRow";
import { UserRow } from "./row/UserRow";
import { UserShortRow } from "./row/UserShortRow";
import { UserUpdateRow } from "./row/UserUpdateRow";

export class NamirasoftAccountServerUser extends NamirasoftAccountServerBase
{
    constructor(server: NamirasoftAccountServer)
    {
        super(server);
        this.Current = this.Current.bind(this);
        this.Register = this.Register.bind(this);
        this.Google = this.Google.bind(this);
        this.Banned = this.Banned.bind(this);
        this.Cancel = this.Cancel.bind(this);
        this.Update = this.Update.bind(this);
        this.Delete = this.Delete.bind(this);
        this._GetByEmail = this._GetByEmail.bind(this);
        this.GetShort = this.GetShort.bind(this);
        this._Get = this._Get.bind(this);
    }
    async Current(): Promise<UserRow>
    {
        let path = `/user/current`;
        let { data } = await this.server._get<UserRow>(path, {});
        return data;
    }
    async Register(body: UserCreateRow): Promise<NamirasoftAccountToken>
    {
        let path = `/user/register`;
        let { data } = await this.server._post<NamirasoftAccountToken>(path, {}, body);
        this.server.manager.set(data, false);
        return data;
    }
    async Google(body: UserCreateByGoogleRow): Promise<NamirasoftAccountToken>
    {
        let path = `/user/google`;
        let { data } = await this.server._post<NamirasoftAccountToken>(path, {}, body);
        this.server.manager.set(data, false);
        return data;
    }
    async Banned(id: string): Promise<UserRow>
    {
        let path = `/user/banned/${id}`;
        let { data } = await this.server._put<UserRow>(path, {});
        this.server.manager.setUser(data);
        return data;
    }
    async Cancel(): Promise<UserRow>
    {
        let path = `/user/cancel`;
        let { data } = await this.server._post<UserRow>(path, {});
        this.server.manager.setUser(data);
        return data;
    }
    async Update(body: UserUpdateRow): Promise<UserRow>
    {
        let path = `/user`;
        let { data } = await this.server._put<UserRow>(path, {}, body);
        this.server.manager.setUser(data);
        return data;
    }
    async Delete(): Promise<UserRow>
    {
        let path = `/user`;
        let { data } = await this.server._delete<UserRow>(path, {});
        this.server.manager.setUser(data);
        return data;
    }
    async _GetByEmail(email: string): Promise<UserFullRow>
    {
        let path = `/application/user/email/${email}`;
        let { data } = await this.server._get<UserFullRow>(path, {});
        return data;
    }
    async GetShort(id: string): Promise<UserShortRow>
    {
        let path = `/user/${id}/short`;
        let { data } = await this.server._get<UserShortRow>(path, {});
        return data;
    }
    async _Get(id: string): Promise<UserFullRow>
    {
        let path = `/application/user/${id}`;
        let { data } = await this.server._get<UserFullRow>(path, {});
        return data;
    }
};